import { Component, input, output } from '@angular/core';
import { NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';
import { SvgIconsComponent } from '@zayan-erp/shared';
import { environment } from '../../../../../../apps/cinari-erp-client/src/environments/environment';

@Component({
  selector: 'app-file-drop',
  imports: [NgxFileDropModule, SvgIconsComponent],
  templateUrl: './file-drop.component.html'
})
export class FileDropComponent {
  fileAcceptedFormat = input<string>(environment.fileFormat);
  titleMsg = input<string>('Upload Files');
  disabled = input<boolean>(false);
  useDragEnter = input<boolean>(true);

  onFileDrop = output<NgxFileDropEntry[]>();
}
